module.exports = __webpack_public_path__ + "img/build.21451fa8.svg";